export enum InventoryItemStatuses {
  Active,
  Blocked,
}
